<template>
  <b-modal
    id="feedback"
    centered
    hide-footer
    hide-header
    size="md"
    no-close-on-backdrop
    @hidden="clearFeedbackForm(), (selectrec = '')"
  >
    <div class="modalheading d-flex align-items-center justify-content-between">
      <span class="feedbk-modal-head">Feedback Form</span>
    </div>
    <div class="line-work">
      <hr />
    </div>

    <div
      v-if="!showSpinner"
      @click="clearFeedbackForm(), (selectrec = '')"
      class="xMarkCancel"
    >
      <img src="../../../assets/cross-round.svg" alt="" />
    </div>
    <b-overlay :show="showSpinner" rounded="sm">
      <div>
        <template>
          <div>
            <b-tabs :class="tabClass">
              <b-tab
                active
                @click="
                  (activeTab = 'giveFeedback'),
                    (context.tabFIndex = 0),
                    resetFeedbacktabs()
                "
              >
                <template #title>
                  <div class="text-break pointer ellipsis">Give Feedback</div>
                </template>
              </b-tab>

              <b-tab
                @click="
                  (activeTab = 'fillFeedback'),
                    (context.tabFIndex = 1),
                    resetFeedbacktabs()
                "
              >
                <template #title>
                  <div class="text-break pointer ellipsis">Fill Feedback</div>
                </template>
              </b-tab>

              <b-tab
                v-if="showReminderTab"
                @click="
                  (activeTab = 'reminder'),
                    (context.tabFIndex = 2),
                    resetFeedbacktabs();
                  getHistory();
                "
              >
                <template #title>
                  <div class="text-break pointer ellipsis">Reminder</div>
                </template>
              </b-tab>
            </b-tabs>
          </div>
        </template>
      </div>

      <template>
        <template v-if="context.tabFIndex == 0">
          <div class="feedbck-height-container">
            <b-row class="mt-3 mr-1">
              <b-col cols="12">
                <div class="topDiv mt-2">
                  <label class="fieldsetStyle"
                    >Candidate Name&nbsp;<span class="asterik">*</span></label
                  >
                  <b-form-input
                    class="jdfeedbackdisableinput"
                    id="input-1"
                    type="text"
                    disabled
                    v-model="context.feedback.name"
                  >
                  </b-form-input>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="topDiv mt-4">
                  <label class="fieldsetStyle"
                    >Panel Name
                    <span
                      v-if="
                        ($route.name === 'JdDetails' &&
                          context.feedback.externalPanelist &&
                          context.feedback.externalPanelist.length != 0) ||
                        ($route.name === 'Kanban' &&
                          context.feedback.externalPanelist &&
                          context.feedback.externalPanelist.length != 0) ||
                        ($route.name === 'vendorCandidates' &&
                          context.feedback.externalPanelist &&
                          context.feedback.externalPanelist.length != 0)
                      "
                      >(external)
                    </span>
                    <span class="asterik">*</span></label
                  >
                  <b-form-input
                    class="jdfeedbackdisableinput"
                    id="input-1"
                    type="text"
                    disabled
                    v-model="context.feedback.panelName"
                  >
                  </b-form-input>
                </div>
              </b-col>

              <b-col cols="12">
                <div class="jdkanban give-feedback-radios mt-3">
                  <div class="d-flex">
                    <div class="feedbck-recommend-font">
                      Recommendation&nbsp;<span class="asterik">*</span>
                    </div>
                    <div
                      class="d-flex align-items-center ml-2"
                      v-if="
                        context.$v.feedback.recommendation.$dirty &&
                        !context.$v.feedback.recommendation.required &&
                        selectrec != 'SE'
                      "
                    >
                      <img
                        src="../../../assets/img/jddetails/feedbackvalidation-jddetails.svg"
                        alt=""
                      />
                      <div class="fdbckvalidation-text ml-2">
                        Please select an option
                      </div>
                    </div>
                  </div>

                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mt-2
                    "
                  >
                    <template
                      v-if="
                        $route.name == 'JdDetails' || $route.name == 'Kanban'
                      "
                    >
                      <b-form-radio
                        v-if="
                          context.activeCandidate.kanbanLevel != 'F' &&
                          $route.name == 'JdDetails'
                            ? context.interviewProcess.process.length - 5 >
                              parseInt(context.activeCandidate.kanbanLevel)
                            : context.interviewProcess.process.length - 4 >
                              parseInt(context.activeCandidate.kanbanLevel)
                        "
                        v-model="selectrec"
                        value="SE"
                        @change="select()"
                      >
                        <div>Select</div>
                      </b-form-radio>
                      <b-form-radio
                        v-else
                        v-model="context.feedback.recommendation"
                        name="some-radios"
                        value="S"
                        @change="radiobtns"
                      >
                        <div>Select</div>
                      </b-form-radio>
                    </template>
                    <template v-else-if="$route.name == 'vendorCandidates'">
                      <b-form-radio
                        v-model="context.feedback.recommendation"
                        name="some-radios"
                        value="S"
                      >
                        <div>Select</div>
                      </b-form-radio>
                    </template>
                    <b-form-radio
                      v-if="context.activeCandidate.kanbanLevel != 'H'"
                      v-model="context.feedback.recommendation"
                      name="some-radios"
                      value="H"
                      @change="radiobtns"
                    >
                      <div>Hold</div>
                    </b-form-radio>
                    <b-form-radio
                      v-model="context.feedback.recommendation"
                      name="some-radios"
                      value="R"
                      @change="radiobtns"
                    >
                      <div>Reject</div>
                    </b-form-radio>
                    <b-form-radio
                      v-show="context.activeCandidate.kanbanLevel != 'F'"
                      v-model="context.feedback.recommendation"
                      name="some-radios"
                      value="NI"
                      @change="radiobtns"
                    >
                      <div>Not interested</div>
                    </b-form-radio>
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <div
                  class="s-fs-box jdkanban give-feedback-radios mt-2"
                  v-if="
                    ($route.name === 'JdDetails' || $route.name === 'Kanban') &&
                    selectrec == 'SE'
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    :class="
                      context.$v.feedback.recommendation.$dirty &&
                      !context.$v.feedback.recommendation.required &&
                      selectrec == 'SE'
                        ? 'p-1'
                        : ''
                    "
                  >
                    <b-form-radio
                      name="some-radios"
                      v-model="context.feedback.recommendation"
                      value="S"
                    >
                      <div>Select for next round</div>
                    </b-form-radio>
                    <b-form-radio
                      class="ml-4"
                      v-model="context.feedback.recommendation"
                      v-b-modal.SelOpsheadFinal
                      name="some-radio"
                      value="FS"
                    >
                      <div>Select to hire</div>
                    </b-form-radio>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                class="pointer"
                v-if="context.feedback.recommendation !== 'NI'"
              >
                <div class="mt-3 custsamename-modal-text">FeedBack Form</div>
                <div
                  :class="
                    feedbackerror == true || resumefailed == true
                      ? 'validation-upload-dot-bg '
                      : ' upload-dot-main upload-dot-bg '
                  "
                  class="upload-dot-main upload-dot-bg mt-3 feedback-modal"
                >
                  <div
                    class="m-0 dot-align relativeclass uploadimage"
                    v-if="!checkMedia1 || fileCheck == false"
                  >
                    <input
                      type="file"
                      multiple
                      class="pointer upload-inputimage"
                      @change="previewFeedback"
                      accept=".pdf , .doc , .txt , .docx"
                    />
                    <div v-if="!checkMedia1 || fileCheck == false">
                      <div>
                        <span class="upload-main-font"
                          >Upload Feedback Form
                          <span class="asterik">*</span>
                        </span>
                      </div>

                      <div>
                        <span class="jd-max-size">Max size : 5mb </span>
                        <div class="jd-max-size">
                          Supported Format : PDF/DOC/TXT/DOCX
                        </div>
                        <div
                          v-if="feedbackerror == true && resumefailed == false"
                          class="jd-upload-doc"
                        >
                          Please upload document
                        </div>
                        <div v-if="resumefailed == true" class="jd-upload-doc">
                          Invalid Format
                        </div>
                        <div
                          v-if="checkMedia1 && fileCheck == false"
                          class="jd-upload-doc"
                        >
                          Please upload less than 5 MB
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="checkMedia1 && fileCheck == true"
                    class="m-0 dot-align"
                  >
                    <div
                      style="width: 95%"
                      class="
                        relativeclass
                        upload-fedbck-filenamebox
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <div class="fedbck-filetextname text-break">
                        {{ feedbackfilename }}
                      </div>
                      <div @click="removefeedback" class="pointer">
                        <img
                          src="../../../assets/img/createjd/fedbckclose.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>

              <b-col
                cols="12"
                class="pointer"
                v-if="context.feedback.recommendation !== 'NI'"
              >
                <div class="mt-3 custsamename-modal-text">Candidate Photo</div>

                <div
                  :class="
                    isFailed == true
                      ? 'validation-upload-dot-bg '
                      : ' upload-dot-main upload-dot-bg mt-3 feedback-modal'
                  "
                >
                  <div
                    class="m-0 dot-align relativeclass uploadimage"
                    v-if="!checkimage || fileCheckImage == false"
                  >
                    <input
                      type="file"
                      multiple
                      class="pointer upload-inputimage"
                      accept="image/jpeg, image/png"
                      @change="previewImage"
                    />
                    <div v-if="!checkimage || fileCheckImage == false">
                      <div>
                        <span class="upload-main-font"
                          >Upload candidate screenshot</span
                        >
                      </div>

                      <div>
                        <span class="jd-max-size">Max size : 5mb</span>
                        <div class="jd-max-size">
                          Supported Format : JPG/JPEG/PNG
                        </div>
                        <div v-if="isFailed == true" class="jd-upload-doc">
                          Invalid Format
                        </div>
                        <div
                          v-if="checkimage && fileCheckImage == false"
                          class="jd-upload-doc"
                        >
                          Please upload less than 5 MB
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="checkimage && fileCheckImage == true"
                    class="m-0 dot-align"
                  >
                    <div
                      style="width: 95%"
                      class="
                        relativeclass
                        upload-fedbck-filenamebox
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <div class="fedbck-filetextname text-break">
                        {{ screenshotname }}
                      </div>
                      <div @click="removeImage()" class="pointer">
                        <img
                          src="../../../assets/img/createjd/fedbckclose.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <div class="topDiv mt-4 previewfdbck-tabs">
                  <label class="fill-feedbck-fieldsetStyle"
                    >Remarks&nbsp;<span class="asterik">*</span></label
                  >
                  <b-form-textarea
                    class="remarksField"
                    id="input-1"
                    type="text"
                    rows="3"
                    max-rows="6"
                    no-resize
                    placeholder="Enter Remarks"
                    v-model.trim="context.$v.feedback.recruiterRemarks.$model"
                    :class="{
                      error: context.$v.feedback.recruiterRemarks.$error,
                    }"
                    v-on:keyup.enter="handleFeedbackClick()"
                  >
                  </b-form-textarea>
                  <div
                    class="validationicon"
                    v-if="
                      context.$v.feedback.recruiterRemarks.$dirty &&
                      !context.$v.feedback.recruiterRemarks.required
                    "
                    v-b-popover.hover.top.v-danger="{
                      content: 'Required',
                    }"
                  >
                    <img src="../../../assets/deletepopupicon.svg" alt="" />
                  </div>
                  <div
                    class="validationicon"
                    v-if="!context.$v.feedback.recruiterRemarks.maxLength"
                    v-b-popover.hover.top.v-danger="{
                      content: 'Should not exceed 256 characters',
                    }"
                    variant="primary"
                  >
                    <img src="../../../assets/deletepopupicon.svg" alt="" />
                  </div>
                </div>
              </b-col>
            </b-row>
            <hr class="feedback-hr-width" />
          </div>
        </template>

        <template v-if="context.tabFIndex == 1">
          <div class="feedbck-height-container relativeclass">
            <div
              class="fillfdbk-name-box text-break relativeclass mt-1"
              v-if="context.feedbackform.name"
            >
              {{ context.feedbackform.name }}
            </div>
            <div class="fillFeedbck-inner-content fillFeedbck-tabs">
              <b-row>
                <b-col cols="12" class="mt-3">
                  <div class="topDiv mt-3">
                    <label class="fieldsetStyle"
                      >Candidate Name&nbsp;<span class="asterik">*</span></label
                    >
                    <b-form-input
                      class="jdfeedbackdisableinput"
                      id="input-1"
                      type="text"
                      disabled
                      v-model="context.feedback.name"
                    >
                    </b-form-input>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="jdkanban give-feedback-radios mt-3">
                    <div class="d-flex">
                      <div class="feedbck-recommend-font">
                        Recommendation&nbsp;<span class="asterik">*</span>
                      </div>
                      <div
                        class="d-flex align-items-center ml-2"
                        v-if="
                          context.$v.feedback.recommendation.$dirty &&
                          !context.$v.feedback.recommendation.required &&
                          selectrec != 'SE'
                        "
                      >
                        <img
                          src="../../../assets/img/jddetails/feedbackvalidation-jddetails.svg"
                          alt=""
                        />
                        <div class="fdbckvalidation-text ml-2">
                          Please select an option
                        </div>
                      </div>
                    </div>

                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mt-2
                      "
                    >
                      <template
                        v-if="
                          $route.name == 'JdDetails' || $route.name == 'Kanban'
                        "
                      >
                        <b-form-radio
                          v-if="
                            context.activeCandidate.kanbanLevel != 'F' &&
                            $route.name == 'JdDetails'
                              ? context.interviewProcess.process.length - 5 >
                                parseInt(context.activeCandidate.kanbanLevel)
                              : context.interviewProcess.process.length - 4 >
                                parseInt(context.activeCandidate.kanbanLevel)
                          "
                          v-model="selectrec"
                          value="SE"
                          @change="select()"
                        >
                          <div>Select</div>
                        </b-form-radio>
                        <b-form-radio
                          v-else
                          v-model="context.feedback.recommendation"
                          name="some-radios"
                          value="S"
                          @change="radiobtns"
                        >
                          <div>Select</div>
                        </b-form-radio>
                      </template>
                      <template v-else-if="$route.name == 'vendorCandidates'">
                        <b-form-radio
                          v-model="context.feedback.recommendation"
                          name="some-radios"
                          value="S"
                        >
                          <div>Select</div>
                        </b-form-radio>
                      </template>
                      <b-form-radio
                        v-if="context.activeCandidate.kanbanLevel != 'H'"
                        v-model="context.feedback.recommendation"
                        name="some-radios"
                        value="H"
                        @change="radiobtns"
                      >
                        <div>Hold</div>
                      </b-form-radio>
                      <b-form-radio
                        v-model="context.feedback.recommendation"
                        name="some-radios"
                        value="R"
                        @change="radiobtns"
                      >
                        <div>Reject</div>
                      </b-form-radio>
                      <b-form-radio
                        v-show="context.activeCandidate.kanbanLevel != 'F'"
                        v-model="context.feedback.recommendation"
                        name="some-radios"
                        value="NI"
                        @change="radiobtns"
                      >
                        <div>Not interested</div>
                      </b-form-radio>
                    </div>
                  </div>
                </b-col>

                <b-col cols="12">
                  <div
                    class="s-fs-box jdkanban give-feedback-radios mt-2"
                    v-if="
                      ($route.name === 'JdDetails' ||
                        $route.name === 'Kanban') &&
                      selectrec == 'SE'
                    "
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                      :class="
                        context.$v.feedback.recommendation.$dirty &&
                        !context.$v.feedback.recommendation.required &&
                        selectrec == 'SE'
                          ? 'p-1'
                          : ''
                      "
                    >
                      <b-form-radio
                        name="some-radios"
                        v-model="context.feedback.recommendation"
                        value="S"
                      >
                        <div>Select for next round</div>
                      </b-form-radio>
                      <b-form-radio
                        class="ml-4"
                        v-model="context.feedback.recommendation"
                        v-b-modal.SelOpsheadFinal
                        name="some-radio"
                        value="FS"
                      >
                        <div>Select to hire</div>
                      </b-form-radio>
                    </div>
                  </div>
                </b-col>

                <b-col
                  cols="12"
                  v-if="context.feedback.recommendation !== 'NI'"
                >
                  <div
                    class="mt-3 fillfdbck-skill-container"
                    v-for="(input, inputindex) in context.feedbackform.skills"
                    :key="inputindex"
                  >
                    <div class="pfdbck-bi-heading text-break">
                      {{ input.name }}
                    </div>

                    <div
                      class="candviewmodalinput relativeclass"
                      v-if="input.markingType == 'rating'"
                    >
                      <label class="mt-2 rating-text-font"
                        >Rating&nbsp;<span
                          v-if="input.mandatory == true"
                          class="asterik"
                          >*</span
                        ></label
                      >
                      <b-form-rating
                        variant="primary"
                        class="mb-2 scorerate p-0 w-25"
                        v-model="input.mark"
                      ></b-form-rating>
                      <div
                        class="jddetails-validationicon-rating"
                        v-if="
                          context.$v.feedbackform.skills.$each[inputindex].mark
                            .$error
                        "
                        v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                      >
                        <img src="../../../assets/deletepopupicon.svg" alt="" />
                      </div>
                    </div>
                    <div class="mt-2" v-if="input.markingType == 'score'">
                      <b-row>
                        <b-col>
                          <div class="topDiv mt-3">
                            <label class="fill-feedbck-fieldsetStyle"
                              >Score&nbsp;<span
                                v-if="input.mandatory == true"
                                class="asterik"
                                >*</span
                              ></label
                            >
                            <b-form-input
                              class="fillfdbk-input"
                              placeholder="Score should be given from 1 - 10"
                              v-model="input.mark"
                              :class="{
                                error:
                                  context.$v.feedbackform.skills.$each[
                                    inputindex
                                  ].mark.$error ||
                                  !context.$v.feedbackform.skills.$each[
                                    inputindex
                                  ].mark.between,
                              }"
                            >
                            </b-form-input>
                            <div
                              class="validationicon"
                              v-if="
                                context.$v.feedbackform.skills.$each[inputindex]
                                  .mark.$error
                              "
                              v-b-popover.hover.top.v-danger="{
                                content: 'Required',
                              }"
                              variant="primary"
                            >
                              <img
                                src="../../../assets/deletepopupicon.svg"
                                alt=""
                              />
                            </div>
                            <div
                              class="validationicon"
                              v-if="
                                !context.$v.feedbackform.skills.$each[
                                  inputindex
                                ].mark.between &&
                                context.$v.feedbackform.skills.$each[inputindex]
                                  .mark.required
                              "
                              v-b-popover.hover.top.v-danger="{
                                content: 'Should be between (1, 10)',
                              }"
                              variant="primary"
                            >
                              <img
                                src="../../../assets/deletepopupicon.svg"
                                alt=""
                              />
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="mt-2" v-if="input.commentMode == true">
                      <div class="topDiv mt-3">
                        <label class="fill-feedbck-fieldsetStyle"
                          >Comments&nbsp;<span
                            v-if="input.mandatory == true"
                            class="asterik"
                            >*</span
                          ></label
                        >
                        <b-form-textarea
                          class="fillfdbk-input"
                          rows="3"
                          max-rows="4"
                          v-model="input.comments"
                          placeholder="Enter comments"
                          :class="{
                            error:
                              context.$v.feedbackform.skills.$each[inputindex]
                                .comments.$error ||
                              !context.$v.feedbackform.skills.$each[inputindex]
                                .comments.maxLength,
                          }"
                        >
                        </b-form-textarea>
                        <div
                          class="validationicon"
                          v-if="
                            context.$v.feedbackform.skills.$each[inputindex]
                              .comments.$error
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Required',
                          }"
                          variant="primary"
                        >
                          <img
                            src="../../../assets/deletepopupicon.svg"
                            alt=""
                          />
                        </div>
                        <div
                          class="validationicon"
                          v-if="
                            !context.$v.feedbackform.skills.$each[inputindex]
                              .comments.maxLength &&
                            context.$v.feedbackform.skills.$each[inputindex]
                              .comments.required
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Should not exceed 256 characters',
                          }"
                          variant="primary"
                        >
                          <img
                            src="../../../assets/deletepopupicon.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col
                  cols="12"
                  class="pointer"
                  v-if="
                    (context.feedback.recommendation !== 'NI' &&
                      context.feedbackform.screenshot == true) ||
                    $route.name === 'vendorCandidates'
                  "
                >
                  <div class="mt-3 fillfdbck-skill-container">
                    <div
                      :class="
                        isFailed == true
                          ? 'validation-upload-dot-bg '
                          : ' upload-dot-main upload-dot-bg mt-3 feedback-modal'
                      "
                    >
                      <div
                        class="m-0 dot-align relativeclass uploadimage"
                        v-if="!checkimage || fileCheckImage == false"
                      >
                        <input
                          type="file"
                          multiple
                          class="pointer upload-inputimage"
                          accept="image/jpeg, image/png"
                          @change="previewImage"
                        />
                        <div v-if="!checkimage || fileCheckImage == false">
                          <div>
                            <span class="upload-main-font"
                              >Upload candidate screenshot</span
                            >
                          </div>

                          <div>
                            <span class="jd-max-size">Max size : 5mb</span>
                            <div class="jd-max-size">
                              Supported Format : JPG/JPEG/PNG
                            </div>
                            <div v-if="isFailed == true" class="jd-upload-doc">
                              Invalid Format
                            </div>
                            <div
                              v-if="checkimage && fileCheckImage == false"
                              class="jd-upload-doc"
                            >
                              Please upload less than 5 MB
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="checkimage && fileCheckImage == true"
                        class="m-0 dot-align"
                      >
                        <div
                          style="width: 95%"
                          class="
                            relativeclass
                            upload-fedbck-filenamebox
                            d-flex
                            align-items-center
                            justify-content-between
                          "
                        >
                          <div class="fedbck-filetextname">
                            {{ screenshotname }}
                          </div>
                          <div @click="removeImage()" class="pointer">
                            <img
                              src="../../../assets/img/createjd/fedbckclose.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col cols="12">
                  <div class="topDiv mt-4">
                    <label class="fill-feedbck-fieldsetStyle"
                      >Remarks&nbsp;<span class="asterik">*</span></label
                    >
                    <b-form-textarea
                      class="remarksField"
                      id="input-1"
                      type="text"
                      rows="3"
                      max-rows="6"
                      no-resize
                      placeholder="Enter Remarks"
                      v-model.trim="context.$v.feedback.recruiterRemarks.$model"
                      :class="{
                        error: context.$v.feedback.recruiterRemarks.$error,
                      }"
                      v-on:keyup.enter="handleFeedbackClick()"
                    >
                    </b-form-textarea>
                    <div
                      class="validationicon"
                      v-if="
                        context.$v.feedback.recruiterRemarks.$dirty &&
                        !context.$v.feedback.recruiterRemarks.required
                      "
                      v-b-popover.hover.top.v-danger="{
                        content: 'Required',
                      }"
                    >
                      <img src="../../../assets/deletepopupicon.svg" alt="" />
                    </div>
                    <div
                      class="validationicon"
                      v-if="!context.$v.feedback.recruiterRemarks.maxLength"
                      v-b-popover.hover.top.v-danger="{
                        content: 'Should not exceed 256 characters',
                      }"
                      variant="primary"
                    >
                      <img src="../../../assets/deletepopupicon.svg" alt="" />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </template>

        <template
          v-if="
            (context.tabFIndex == 2 && context.activeCandidate.type == 'f2f') ||
            (context.activeCandidate.kanbanLevel == 'F' &&
              context.tabFIndex == 2) ||
            (context.tabFIndex == 2 &&
              context.jdDetails.vendorConfig.sendFeedbackRemainder == true)
          "
        >
          <div class="feedbck-height-container p-2">
            <div class="mt-3 set-reminder-font">
              Send a Reminder to Panelist for Face to Face round
            </div>
            <div class="mt-2 mg-right-subhead">
              Panelist will get a reminder to fill feedback form
            </div>
            <hr />
            <!-- shimmer start -->

            <div v-if="showShimmer" class="mt-4">
              <span>
                <b-skeleton class="w-25"></b-skeleton>
              </span>

              <div class="sentTo-history-task-container mt-4">
                <div
                  v-for="(i, index) in loopvar"
                  :key="index"
                  class="d-flex w-100"
                >
                  <div class="d-flex flex-column align-items-center mr-3">
                    <div class="skel-class-feedback">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <div class="fb-line"></div>
                  </div>
                  <div class="w-100">
                    <b-skeleton class="w-25"></b-skeleton>

                    <div class="d-flex align-items mt-2 w-75">
                      <div class="d-flex align-items-start">
                        <b-skeleton type="avatar"></b-skeleton>
                      </div>
                      <div class="ml-2 w-75">
                        <div class="pfdbck-heading">
                          <b-skeleton class="w-100"></b-skeleton>
                        </div>
                        <div class="hist-date-font mt-2">
                          <b-skeleton class="w-100"></b-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- shimmer end -->

            <div
              v-else-if="
                showShimmer === false && getReminderHistory.length !== 0
              "
              class="mt-2"
            >
              <span class="sent-history-text">Sent History</span>

              <div class="sentTo-history-task-container">
                <div
                  v-for="(j, index) in getReminderHistory"
                  :key="index"
                  class="d-flex"
                >
                  <template>
                    <div
                      class="sentTo-history-box"
                      :class="{
                        'no-history-line': index == getReminderHistory - 1,
                      }"
                    >
                      <img
                        src="../../../assets/img/jddetails/assigned-newDot.svg"
                        alt=""
                      />
                    </div>
                  </template>
                  <div style="margin-top: 0.67rem">
                    <div class="testconfig-card-subheads">Sent To</div>

                    <div class="d-flex align-items mt-2">
                      <div class="d-flex align-items-start">
                        <img
                          src="../../../assets/img/jddetails/assignedTo-individual.svg"
                          alt=""
                        />
                      </div>
                      <div class="ml-2">
                        <div
                          class="pfdbck-heading"
                          v-for="(i, index2) in j.sendTo"
                          :key="index2"
                        >
                          {{ i }}
                        </div>
                        <div class="hist-date-font mt-2">
                          {{ j.createdAt.slice(0, -8) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="showShimmer == false && getReminderHistory.length == 0"
              class="mt-4"
            >
              <span class="sent-history-text">Sent History</span>
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  text-center
                  mt-4
                "
              >
                Currently there is no sent history
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="d-flex align-items-center justify-content-end mt-2">
        <b-button
          class="addbtn"
          v-if="activeTab == 'reminder'"
          @click="panelDetails()"
          >Send
        </b-button>
        <b-button class="addbtn" v-else @click="handleFeedbackClick()"
          >Submit</b-button
        >
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import { panelDetails, savefeedback } from "../asynchronous";
import {
  savefeedbackform,
  getSentHistory,
} from "../../../utils/apiFunctions.js";

import {
  removeImage,
  previewImage,
  previewFeedback,
  removefeedback,
  clearFeedbackForm,
} from "../helpers";
export default {
  name: "FeedbackModal",
  props: {
    context: Object,
  },
  data() {
    return {
      showShimmer: false,
      loopvar: 2,
      getReminderHistory: [],
      activeTab: "giveFeedback",
      selectrec: null,
      candidateInterviewRound: {},
      isFailed: false,
      showSpinner: false,
      image: null,
      screenshotname: null,
      feedbackfilename: "",

      fileCheck: false,
      fileCheckImage: false,
      checkMedia1: false,
      resumefailed: false,

      feedbackerror: false,
      checkimage: false,
    };
  },
  computed: {
    tabClass() {
      if (this.$route.name === "vendorCandidates") {
        return this.context.jdDetails.vendorConfig.sendFeedbackRemainder
          ? "feedbck-tabs"
          : "feedbck-f2f-tabs";
      } else if (
        this.$route.name === "JdDetails" ||
        this.$route.name === "Kanban"
      ) {
        return this.context.activeCandidate.type === "f2f" ||
          this.context.activeCandidate.kanbanLevel === "F"
          ? "feedbck-tabs"
          : "feedbck-f2f-tabs";
      }
      return "feedbck-tabs"; // Default value
    },
    showReminderTab() {
      // Default value if none of the conditions match
      let defaultValue = false;

      // Determine whether to show the Reminder tab
      if (this.$route.name === "vendorCandidates") {
        return this.context.jdDetails.vendorConfig.sendFeedbackRemainder;
      } else if (
        this.$route.name === "JdDetails" ||
        this.$route.name === "Kanban"
      ) {
        return (
          this.context.activeCandidate.type === "f2f" ||
          this.context.activeCandidate.kanbanLevel === "F"
        );
      }

      // Return the default value if none of the conditions match
      return defaultValue;
    },
  },

  methods: {
    handleFeedbackClick() {
      if (this.$route.name === "JdDetails" || this.$route.name === "Kanban") {
        this.savefeedback();
        this.activeTab = "giveFeedback";
        this.selectrec = "";
      } else if (this.$route.name === "vendorCandidates") {
        this.saveVendorfeedback();
      }
    },
    async getHistory() {
      this.showShimmer = true;

      let payload = {
        interviewID: this.context.activeCandidate.kanbanInterviewID,
        remainder: true,
      };
      const res = await getSentHistory(payload);
      if (res.status == 200) {
        this.getReminderHistory = res.data.data;
        this.showShimmer = false;
      }
    },

    vendorFeedback() {
      if (this.resumeFiles == "" && this.feedback.recommendation != "NI") {
        this.feedbackerror = true;
      } else {
        this.feedbackerror = false;
      }
    },

    setupFeedbackItem(item) {
      if (item["candidateImage"] != undefined || item["candidateImage"] != "") {
        if (this.image == undefined || item.candidateImage == undefined) {
          delete this.image;
          delete item.candidateImage;
        } else if (this.image !== "") {
          item["candidateImage"] = this.image;
        }
      }

      if (item["feedbackForm"] != undefined && item["feedbackForm"] != "") {
        item["feedbackForm"] = this.context.resumeFiles;
        item["processedBy"] = "Recruiter";

        delete item.customFeedback;
      } else if (
        item["customFeedback"] != undefined ||
        item["customFeedback"] != ""
      ) {
        item["customFeedback"] = JSON.stringify(
          this.context.feedback.customFeedback
        );
        item["processedBy"] = "PanelThruRecruiter";
        delete item.feedbackForm;
      } else {
        delete item.customFeedback;
      }

      item["name"] = this.context.activeCandidate.name;
      item["interviewID"] = this.context.activeCandidate.kanbanInterviewID;
    },

    async saveVendorfeedback() {
      try {
        this.vendorFeedback();

        this.context.$v.feedback.$touch();
        this.context.$v.feedbackform.$touch();
        if (
          (!this.feedbackerror &&
            !this.context.$v.feedback.$invalid &&
            !this.isFailed) ||
          (!this.context.$v.feedback.$invalid &&
            !this.context.$v.feedbackform.$invalid)
        ) {
          const date = new Date();
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          this.context.feedbackform.basicInfo.name =
            this.context.activeCandidate.name;
          this.context.feedbackform.basicInfo.evalDate = `${day}-${month}-${year}`;
          this.context.feedbackform.basicInfo.panel =
            this.context.feedback.panelName;
          this.context.feedbackform.basicInfo.experience =
            this.context.activeCandidate.experince;
          this.context.feedbackform.basicInfo.modeOfInterview =
            this.context.activeCandidate.interviewType;
          let form = new FormData();

          this.context.feedback.customFeedback = this.context.feedbackform;

          let item = { ...this.context.feedback };

          this.setupFeedbackItem(item);

          for (let key in item) {
            form.append(key, item[key]);
          }
          const response = await savefeedbackform(form);
          if (response.status == 200) {
            this.context.getVendor();
            this.context.clearFeedbackForm();
            this.context.successModal("Feedback Given Successfully");
            this.checkMedia1 = false;
            this.checkimage = false;
          } else if (response.status == 400) {
            this.context.errorModal(response.data.data.Detail);
            this.context.clearFeedbackForm();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async panelDetails() {
      await panelDetails(this.context, this);
    },
    radiobtns() {
      this.selectrec = "";
    },
    async savefeedback() {
      this.showSpinner = true;
      await savefeedback(this.context, this);
      this.showSpinner = false;
    },
    removeImage() {
      removeImage(this.context, this);
    },
    previewImage(event) {
      previewImage(this.context, event, this);
    },

    previewFeedback(event) {
      previewFeedback(this.context, event, this);
    },
    resetFeedbacktabs() {
      removefeedback(this.context, this);
      removeImage(this.context, this);
      this.context.feedback.recruiterRemarks = "";
      this.context.feedback.recommendation = "";
      this.selectrec = "";
      this.feedbackerror = false;
      this.context.$v.$reset();
    },
    removefeedback() {
      removefeedback(this.context, this);
    },
    select() {
      this.context.feedback.recommendation = "";
      if (this.selectrec === "SE") {
        // Automatically select "Select for next round"
        this.context.feedback.recommendation = "S";
      }
    },

    clearFeedbackForm() {
      clearFeedbackForm(this.context, this);
    },
  },
};
</script>

<style>
input[type="file"] {
  opacity: 0;
}

.feedbck-f2f-tabs {
  width: 550px;
}

.feedbck-f2f-tabs .nav-tabs {
  border-radius: 8px;
  background: #fafafa;
  border: unset !important;
  min-width: auto;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  transition: border 250ms ease;
}

.feedbck-f2f-tabs .nav-tabs .nav-link {
  width: 235px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: unset !important;
  border-bottom: unset !important;
  color: #545454 !important;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 15px;
}

.feedbck-f2f-tabs .nav-tabs .nav-link.active {
  border: unset;
  border-bottom: 2px solid #72738e !important;
  background: #ffffff;
  color: #545454 !important;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 15px;
}

.feedbck-tabs {
  width: 550px;
}

.feedbck-tabs .nav-tabs {
  border-radius: 8px;
  background: #fafafa;
  border: unset !important;
  min-width: auto;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  transition: border 250ms ease;
}
.skel-class-feedback .b-skeleton-avatar {
  width: 0.8em;
  height: 0.8em;
  border-radius: 53%;
}
.feedbck-tabs .nav-tabs .nav-link {
  border: unset !important;
  border-bottom: unset !important;
  width: 150px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #545454 !important;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 15px;
}

.feedbck-tabs .nav-tabs .nav-link.active {
  border: unset;
  border-bottom: 2px solid #72738e !important;
  background: #ffffff;
  color: #545454 !important;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 15px;
}
.sent-history-text {
  font-size: 14px;
  color: #464667;

  font-weight: 500;
}
</style>
